import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightCircle,  Users} from 'lucide-react';
import { Link } from 'react-router-dom';

const AboutSection: React.FC = () => {
    return (
        <section className="relative min-h-screen md:min-h-[20vh] py-16 md:py-24 overflow-hidden">
            {/* Decorative background elements */}
            <div className="absolute inset-0 bg-gradient-to-br from-red/50 to-white z-0" />
            <div className="absolute -top-32 -right-32 w-64 h-64 bg-yellow-100 rounded-full blur-3xl" />
            <div className="absolute -bottom-32 -left-32 w-64 h-64 bg-red-100 rounded-full blur-3xl" />

            <div className="container mx-auto px-4 relative z-10">
                <div className="grid md:grid-cols-2 gap-12 items-center">
                    {/* Left content column */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                        className="space-y-6"
                    >
                        <div className="inline-block">
                            <span className=" text-black px-4 py-2 rounded-full text-sm font-medium">
                                Welcome to Greh Pravesh
                            </span>
                        </div>

                        <h2 className="text-3xl md:text-4xl font-bold text-orange-400">
                            Redefinig Mental Health Space
                        </h2>

                        <p className="text-lg text-gray-600">
                            Greh Pravesh was founded as a platform for supportive, non-exploitative communities for therapists in India. The psychologists do not work for us, they’re part of a collective for learning and collaboration.
                        </p>
                        <p className="text-lg text-gray-600">
                            The idea is to ensure that people get the best therapy driven by care and not by profits. We standardise expertise, ensure quality and consistently improve on our work.     
                        </p>
                        <p className='text-lg text-gray-600'>
                          At Greh Pravesh, therapists are not pushed to overwork, to generate profits or to on-board lots of clients stretching themselves too thin.   
                        </p>
                        <p className='text-lg text-gray-600'>
                            We create a warm, nurturing environment where healing begins naturally. Designed to feel like a second home, our sessions ensure every individual's journey towards mental wellness is honored and supported.
                        </p>

                        {/* <div className="grid grid-cols-2 gap-6 pt-4">
                            <div className="flex items-start space-x-3">
                                <Heart className="text-teal-900 mt-1" size={20} />
                                <div>
                                    <h3 className="font-semibold text-teal-700">Compassionate Care</h3>
                                    <p className="text-gray-600">Personalized support for your unique journey</p>
                                </div>
                            </div>
                            <div className="flex items-start space-x-3">
                                <Home className="text-teal-900 mt-1" size={20} />
                                <div>
                                    <h3 className="font-semibold text-teal-700">Safe Space</h3>
                                    <p className="text-gray-600">Where comfort meets professional guidance</p>
                                </div>
                            </div>
                        </div> */}

                        <div className="flex flex-col sm:flex-row gap-4 pt-6">
                            <Link
                                to="/about"
                                className="inline-flex items-center justify-center px-6 py-3 bg-orange-400 text-white rounded-xl hover:bg-golden/90 transition-colors"
                            >
                                Learn More
                                <ArrowRightCircle className="ml-2" size={20} />
                            </Link>
                            <Link
                                to="/our-team"
                                className="inline-flex items-center justify-center px-6 py-3 border-2 border-teal-600 text-teal-800 rounded-xl hover:bg-golden/10 transition-colors"
                            >
                                Meet Our Team
                                <Users className="ml-2" size={20} />
                            </Link>
                        </div>
                    </motion.div>

                    {/* Right image/card column */}

                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                        viewport={{ once: true }}
                        className="relative"
                    >
                        <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                            <img
                                src="/images/safe-haven.jpg"
                                alt="Greh Pravesh Therapy Space"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                        </div>

                        {/* Updated overlay card for better mobile visibility */}
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.6 }}
                            viewport={{ once: true }}
                            className="absolute bottom-0 left-0 right-0 md:-bottom-6 md:-right-6 md:left-auto bg-black/10 backdrop-blur-sm p-6 rounded-b-xl md:rounded-xl shadow-lg md:max-w-xs"
                        >
                            <h4 className="text-lg font-semibold text-white mb-2">Our Team</h4>
                            <p className="text-white/90 text-sm md:text-base">
                                Led by experienced professionals who blend expertise with empathy, our team is dedicated to supporting you through every step of your mental health journey.
                            </p>
                        </motion.div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
